import React from 'react';

import Timeline from '../Timeline/Timeline';
import DetailTimelineOrig from 'ROOT/src/components/detailView/DetailTimeline';
import Select from 'ROOT/src/components/formElements/Select';
import sAction from 'sAction';

export default class DetailTimeline extends DetailTimelineOrig {
    render() {
        const data = this.props.data;
        const module = this.props.module;
        const field = this.props.field;
        const listType = data.list.get('type');

        let selectValue = null;

        const timeLineData = [];
        if (listType == 'list') {
            const list = sAction.app_strings[data.list.get('name')];
            list.forEachObject((label, value) => {
                if (value != '') {
                    timeLineData.push({
                        value: value,
                        label: label,
                        title: sAction.translate(data.titles.get(value), module),
                        clickAble: data.onClick.get(value) !== null ? true : false,
                    });
                }
            });
            selectValue = field.value;
        } else if (listType == 'custom') {
            const list = data.list.get('value');
            list.entrySeq().forEach((k) => {
                timeLineData.push({
                    value: k[0],
                    label: sAction.translate(k[1].label, module),
                    title: sAction.translate(data.titles.get(k[0]), module),
                    clickAble: data.onClick.get(k[0]) !== null ? true : false,
                });

                const values = k[1].values;
                if (values.includes(field.value)) {
                    selectValue = k[0];
                }
            });
        }

        const defaultColor = sAction.param.defaultColor;
        let color = data.colors.get(selectValue);
        if (color == undefined) {
            color = defaultColor;
        }

        const selectValueData = {value: selectValue, color: color};

        return (
            <Timeline
                data={timeLineData}
                value={selectValueData}
                clickable={data.clickable}
                onSelect={(e, value) => this.onSelect(e, value)}
            />
        );
    }
}
